<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon points="6,7 2.5,4 2.5,6 6,9 9.5,6 9.5,4" />
</svg>
</template>